import { render, staticRenderFns } from "./contentFeedback.vue?vue&type=template&id=fa0685fc&scoped=true"
import script from "./contentFeedback.vue?vue&type=script&lang=js"
export * from "./contentFeedback.vue?vue&type=script&lang=js"
import style0 from "./contentFeedback.vue?vue&type=style&index=0&id=fa0685fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0685fc",
  null
  
)

export default component.exports